import { conditionalBranchMessage } from '../functions'

export default {
  function: {
    upload_common: {
      conditional_branch_message: (args: any) =>
        conditionalBranchMessage(args, (triggerQuestionSelectMetaList) => {
          if (triggerQuestionSelectMetaList.length === 1) {
            const { categoryName, questionDisplayNumber, selectText } = triggerQuestionSelectMetaList[0]
            return `Pour ceux qui ont répondu « ${selectText} » au n° ${questionDisplayNumber} de ${categoryName} (obligatoire).`
          }

          const messages = triggerQuestionSelectMetaList.map(
            ({ categoryName, questionDisplayNumber, selectText }) => {
              return `« ${selectText} » au n° ${questionDisplayNumber} de ${categoryName} `
            }
          )
          return `Pour ceux qui ont répondu ${messages.join(' ou ')} (Question obligatoire)`
        }),
    },
    validation: {
      decimal_max_digit: "Saisissez jusqu'à la {decimalMaxDigit}ème décimale",
    },
  }
}
